import { handleInteractiveKeyDown } from './cardUtils';

const PlayerCard = ({
  player,
  onClick,
  onEdit,
  onView,
  onManage,
  showActions = true,
  compact = false,
}) => {
  const interactive = typeof onClick === 'function';
  const profilePhoto = player?.profilePhoto || player?.avatar || '/avatar.png';

  return (
    <article
      className={`card common-entity-card ${interactive ? 'common-entity-card--interactive' : ''} ${compact ? 'common-entity-card--compact' : ''}`}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={() => onClick?.(player)}
      onKeyDown={(event) => handleInteractiveKeyDown(event, () => onClick?.(player))}
    >
      <div className="card-body common-entity-card__body">
        <div className="d-flex gap-3 align-items-start">
          <div className="common-entity-card__avatar">
            <img src={profilePhoto} alt={player?.personal?.fullName || player?.name || 'Player'} />
          </div>
          <div className="flex-grow-1">
            <h3 className="h6 mb-1 common-entity-card__title">{player?.personal?.fullName || player?.name || 'Unnamed player'}</h3>
            <p className="common-entity-card__meta mb-1">{player?.skills?.primaryRole || 'Role TBD'}</p>
            <p className="common-entity-card__meta mb-0">{player?.personal?.city || 'City TBD'}</p>
          </div>
        </div>

        <div className="common-entity-card__chips">
          {player?.skills?.battingStyle ? <span className="badge text-bg-secondary rounded-pill">{player.skills.battingStyle}</span> : null}
          {player?.skills?.bowlingStyle ? <span className="badge text-bg-success rounded-pill">{player.skills.bowlingStyle}</span> : null}
        </div>

        {showActions ? (
          <div className="common-entity-card__actions">
            {onView ? <button type="button" className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); onView(player); }}>View</button> : null}
            {onManage ? <button type="button" className="btn btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); onManage(player); }}>Manage</button> : null}
            {onEdit ? <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => { e.stopPropagation(); onEdit(player); }}>Edit</button> : null}
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default PlayerCard;
